import {apiClient} from 'core/apiClient';
import {RemarkingDictionaryResponse, RemarkingReportClientRequest} from 'types';

export async function fetchRemarkingDictionary(): Promise<RemarkingDictionaryResponse> {
    return (
        await apiClient.get<RemarkingDictionaryResponse>('/marking/dictionary/remarking', {
            baseURL: '/api/v2',
        })
    ).data;
}

export async function createRemarkingDocument(params: RemarkingReportClientRequest) {
    return (
        await apiClient.post<{reportId: string}>('/marking/remarking', params, {
            baseURL: '/api/v2',
        })
    ).data;
}
